import { ILearning } from "./interfaces";
import { AxiosInstance } from "axios";

export function getLearningConceptParentBuilder(apiClient: AxiosInstance) {
  return async function getLearningConceptParent(
    id: number
  ): Promise<ILearning.LectureVideo | null> {
    try {
      const response = await apiClient.get(
        `/learning/api/concepts/${id}/parent/`
      );
      return response.data.results;
    } catch {
      return null;
    }
  };
}
